module.exports = __webpack_public_path__ + "static/media/kibecat.43e01533.webp";